@let promo = promotion();

<div class="ui-promotion-card">
  <div class="ui-promotion-card__image-wrap">
    <img
      class="ui-promotion-card__image"
      [src]="promo.image"
      [alt]="promo.imageAlt || promo.title"
    />
  </div>
  <div class="ui-promotion-card__details">
    <h3 class="ui-promotion-card__title">{{ promo.title }}</h3>
    <p class="ui-promotion-card__validity">
      {{ validityLabel() }}: {{ promo.validFrom }} al {{ promo.validTo }}
    </p>
    <p class="ui-promotion-card__description">{{ promo.description }}</p>
    <ui-button variant="ghost" size="sm" (pressed)="detailsClick.emit()">
      {{ detailsLabel() }}
    </ui-button>
  </div>
  <div class="ui-promotion-card__projects">
    <h4 class="ui-promotion-card__projects-heading">{{ projectsLabel() }}</h4>
    <ul class="ui-promotion-card__projects-list">
      @for (project of visibleProjects(); track project) {
        <li class="ui-promotion-card__project">{{ project }}</li>
      }
    </ul>
  </div>
</div>
